import Header from "./header";
import Root from "./root";
import Body from "./body";

export const LayoutTable = {
    Root,
    Body,
    Header,
};
